<template>
  <div>
    <p class>Buscaste:</p>
    <b-row class="respuesta row col-lg-12 mx-auto mb-3 px-0">
      <div class="col-lg-7 px-0 mb-3 mr-md-3">
        <b-row class="col-12 border-gris-claro p-0 ml-0">
          <div class="col-10 dkt d-md-inline mb-md-1 mt-md-1 py-1 px-1">
            <b-badge
              variant="light"
              class="m-1"
              :class="busqueda.filtro.length > pantalla ? 'truncate' : ''"
              v-for="busqueda in getBusquedasAplicadas"
              :key="busqueda.index"
            >
              {{formatearFiltro(busqueda)}}
              <span>
                <a @click="borrarFiltro(busqueda)" v-if="busqueda.eliminable">
                  <FontAwesomeIcon icon="times" class="ml-2" />
                </a>
              </span>
            </b-badge>
          </div>
          <div class="d-inline ml-auto" style="z-index: 50; background-color: #6C757D;">
            <button
              @click="reiniciarFiltros"
              class="btn btn-secondary rounded-0 order-md-1"
              type="button"
              v-b-tooltip.hover
              title="Borrar todos los filtros"
            >
              <FontAwesomeIcon icon="times" />
            </button>
          </div>
        </b-row>
      </div>
      <div class="col text-lg-right d-inline ml-0 mr-md-0 px-0 d-flex">
        <div class="buscador btn-group col-md-9 mb-lg-0 px-0 mr-md-2 d-flex">
          <div class="px-0 flex-grow-1">
            <b-form-select
              class="custom-select multiple ordenar"
              v-model="criterioOrdenSeleccionado"
              @change="cambiarOrden"
              :disabled="tagSeleccionado === 'lista'"
            >
              <option disabled value="null">Ordenar resultados</option>
              <option
                v-for="criterio in criteriosOrden"
                :key="criterio.index"
                :value="criterio.valor"
              >{{criterio.texto}}</option>
            </b-form-select>
          </div>
        </div>
        <div class="btn-group btn-group-toggle row ml-3 text-right d-none d-lg-inline-block">
          <b-button
            class="tarj rounded-0"
            @click="cambiarVista('detalle')"
            variant="secondary"
            type="button"
            :pressed="tagSeleccionado === 'detalle'"
            id="inputGroupFile03"
            v-b-tooltip.hover
            title="Vista en tarjetas"
          >
            <FontAwesomeIcon icon="th" />
          </b-button>
          <b-button
            class="tarj rounded-0"
            @click="cambiarVista('lista')"
            variant="secondary"
            type="button"
            :pressed="tagSeleccionado === 'lista'"
            id="inputGroupFile02"
            v-b-tooltip.hover
            title="Vista en listado"
          >
            <FontAwesomeIcon icon="align-justify" />
          </b-button>
        </div>
        <!--<p class="pl-0 pt-3">Encontramos {{cantidadResultados}} resultados</p>-->
      </div>
    </b-row>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTimes,
  faTh,
  faAlignJustify,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Busqueda from "@/utils/Busqueda.js";
import { mapGetters, mapActions } from "vuex";
import ApiRegiones from "@/services/ApiRegiones";
library.add(faTimes, faTh, faAlignJustify);
export default {
  name: "TagsBusqueda",
  props: {
    tagSeleccionado: {
      type: String,
    },
    cantidadResultados: {
      type: Number,
    },
    busquedasRealizadas: {
      type: Array,
    },
  },
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      criterioOrdenSeleccionado: null,
    };
  },
  watch: {
    getCriterioOrden(val) {
      this.criterioOrdenSeleccionado = val;
    },
    getRegionSeleccionada(val) {
      if (val === null) {
        this.borrarFiltroDeseleccionado("REGION");
      }
    },
    getAreaConocimientoSeleccionada(val) {
      if (val === null) {
        this.borrarFiltroDeseleccionado("SECTOR");
      }
    },
    getCarreraGenericaSeleccionada(val) {
      if (val === null) {
        this.borrarFiltroDeseleccionado("C_GENERICA");
      }
    },
    getInstitucionSeleccionada(val) {
      if (val === null) {
        this.borrarFiltroDeseleccionado("INSTITUCION");
      }
    },
    getBusquedasAplicadas() {
      this.limpiarCriterioOrden();
    },
    getJornada(val) {
      if (val === null) {
        this.borrarFiltroDeseleccionado("JORNADA");
      }
    },
  },
  computed: {
    ...mapGetters([
      "getCriterioOrden",
      "getBusquedasAplicadas",
      "getRegionSeleccionada",
      "getNombreCarreraSeleccionada",
      "getAreaConocimientoSeleccionada",
      "getCarreraGenericaSeleccionada",
      "getInstitucionSeleccionada",
      "getJornada",
    ]),
    criteriosOrden() {
      return Busqueda.criteriosOrdenCarreraTP();
    },
    regiones() {
      return ApiRegiones.getRegionesYComunas();
    },
    pantalla() {
      if (screen.width < 1024) {
        return 35;
      } else {
        return 75;
      }
    },
  },
  methods: {
    ...mapActions([
      "clearSeleccionados",
      "setBusqueda",
      "setRegionSeleccionada",
      "setNombreCarreraSeleccionada",
      "setAreaConocimientoSeleccionada",
      "setCarreraGenericaSeleccionada",
      "setInstitucionSeleccionada",
      "setJornada",
    ]),
    cambiarVista(valor) {
      this.$emit("cambiarVista", valor);
    },
    formatearFiltro(busqueda) {
      let filtroFormateado = busqueda.filtro;
      switch (busqueda.tipo) {
        case "REGION":
          if (filtroFormateado !== "TODAS") {
            let nuevoText = this.regiones.find(
              (i) => i.valorBusqueda === filtroFormateado
            );
            filtroFormateado = nuevoText.nombreRegion;
          } else {
            filtroFormateado = "Región: Todas";
          }
          filtroFormateado = filtroFormateado.replace(/(DEL_|DE_)/, "");
          filtroFormateado = filtroFormateado.replace(/(_)/gi, " ");
          break;
        case "SECTOR":
          if (filtroFormateado === "TODAS") {
            filtroFormateado = "Sector productivo: Todas";
          }
          break;
        case "C_GENERICA":
          if (filtroFormateado === "TODAS") {
            filtroFormateado = "Carrera genérica: Todas";
          }
          break;
        case "INSTITUCION":
          if (filtroFormateado === "TODAS") {
            filtroFormateado = "Institución: Todas";
          }
          break;
        case "JORNADA":
          switch (busqueda.filtro) {
            case "DIURNO":
              filtroFormateado = "Presencial Diurna";
              break;
            case "VESPERTINO":
              filtroFormateado = "Presencial Vespertina";
              break;
            case "A_DISTANCIA":
              filtroFormateado = "A Distancia";
              break;
            case "TODAS":
              filtroFormateado = "Modalidad: Todas";
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
      return filtroFormateado;
    },
    borrarFiltroDeseleccionado(nombre) {
      let filtro = {
        tipo: nombre,
      };
      this.borrarFiltro(filtro);
    },
    borrarFiltro(filtro) {
      let filtrosAplicados = [...this.getBusquedasAplicadas];
      let indiceFiltro = filtrosAplicados.findIndex(
        (f) => f.tipo === filtro.tipo
      );
      this.borrarFiltroBusquedaAplicada(filtro);
      if (indiceFiltro !== -1) {
        filtrosAplicados.splice(indiceFiltro, 1);
      }
      this.setBusqueda(filtrosAplicados);
      let nuevabusqueda = {
        region: this.getRegionSeleccionada,
        carrera: this.getNombreCarreraSeleccionada,
        sectorProductivo: this.getAreaConocimientoSeleccionada,
        nombreCarreraGenerico: this.getCarreraGenericaSeleccionada,
        nombreInstitucion: this.getInstitucionSeleccionada,
        jornada: this.getJornada,
      };
      this.$emit("buscarCarrera", nuevabusqueda);
    },
    borrarFiltroBusquedaAplicada(filtro) {
      switch (filtro.tipo) {
        case "REGION":
          this.setRegionSeleccionada(null);
          break;
        case "CARRERA":
          this.setNombreCarreraSeleccionada("");
          break;
        case "SECTOR":
          this.setAreaConocimientoSeleccionada(null);
          break;
        case "C_GENERICA":
          this.setCarreraGenericaSeleccionada(null);
          break;
        case "INSTITUCION":
          this.setInstitucionSeleccionada(null);
          break;
        case "JORNADA":
          this.setJornada(null);
          break;
        default:
          break;
      }
    },
    reiniciarFiltros() {
      this.clearSeleccionados();
      this.setBusqueda([]);
      let limpiarBusqueda = {
        region: null,
        carrera: "",
        sectorProductivo: null,
        nombreCarreraGenerico: null,
        nombreInstitucion: null,
        jornada: null,
      };
      this.$emit("buscarCarrera", limpiarBusqueda);
    },
    cambiarOrden() {
      this.$emit("cambiarOrden", this.criterioOrdenSeleccionado);
    },
    limpiarCriterioOrden() {
      this.criterioOrdenSeleccionado = null;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/buscadorTP/TagsBusqueda.vue